import { IRequesterInfo, KeyValuePair } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { addDealerType, addExcludeTestDealers } from '../analyticsQuery'
import { IChatDealerUsageReport, IDealerUsageParams } from '../models'

export class GetDealerUsageApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({ url: 'admin/chatbot-analytics/dealer-usage', requesterInfo })
  }

  public async getReport(params: IDealerUsageParams): Promise<IChatDealerUsageReport> {
    const query = new KeyValuePair<string>()
    query.add('fromUtc', params.fromUtc.toISOString())
    query.add('toUtc', params.toUtc.toISOString())
    if (params.search) query.add('search', params.search)
    if (params.sortBy) query.add('sortBy', params.sortBy)
    if (params.sortDir) query.add('sortDir', params.sortDir)
    query.add('page', String(params.page))
    query.add('pageSize', String(params.pageSize))
    query.add('export', String(params.export))
    addExcludeTestDealers(query, params.excludeTestDealers)
    addDealerType(query, params.dealerType)
    this.queryParams = query
    return await this.getAsync<IChatDealerUsageReport>()
  }
}
